import { useEffect } from 'react';
import Panel from 'components/panel/Panel';
import Loader from 'components/loader/Loader';
import { getLocalDateFormat } from 'utils/date';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import usePostMessage from 'hooks/utils/usePostMessage';
import { useIntl } from 'react-intl';
import messages from 'messages';
import PersonProgramExercisesList from 'containers/partials/lists/PersonProgramExercisesList';
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch
} from 'react-router-dom';
import useProgram from 'hooks/queries/useProgram';
import { useStore } from 'stores/Store';
import {
  ROUTE_USER_ENTITY_PROGRAMS_PROGRAM,
  ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE
} from 'routes/RouteList';

const Program = () => {
  const intl = useIntl();
  const { push } = useHistory();
  const { entityId, programId, exerciseId } = useParams();
  const active = useRouteMatch([ROUTE_USER_ENTITY_PROGRAMS_PROGRAM]);

  const { fetchProgram, error, loading } = useProgram();
  const program = useStore(state => state.program);

  useEffect(() => {
    if (programId) {
      fetchProgram({ variables: { id: programId } });
    }
  }, [programId]);

  const { sendMessage } = usePostMessage();

  useEffect(() => {
    if (program && !loading) {
      const data = {
        title: program.title,
        description: intl.formatMessage(messages.exercisesProgramSubTitle, {
          startdate: getLocalDateFormat(program.startdate),
          duration: program.duration
        }),
        canGoBack: true
      };

      sendMessage({ message: data });
    }
  }, [program, loading]);

  const onExerciseClickHandler = exerciseId => {
    push(
      generatePath(ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE, {
        entityId,
        programId: program.id,
        exerciseId: exerciseId
      })
    );
  };

  if (!program)
    return (
      <Panel active={active?.isExact}>
        <Loader />
      </Panel>
    );
  if (error) return <RetryPanel />;

  return (
    <Panel active={active?.isExact}>
      <PersonProgramExercisesList
        exercises={program.exercises}
        onClick={onExerciseClickHandler}
        activeId={exerciseId}
      />
    </Panel>
  );
};

export default Program;
